import React, { useMemo } from "react";
import { Breadcrumbs, Grid, Link, Typography } from "@mui/material";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

const StyledLink = styled(Link)`
  :hover {
    cursor: pointer;
  }
`;

const DocumentBreadcrumb = ({
  path = "",
  setQuery,
  userName = "",
  setSearchedText,
}) => {
  const paths = useMemo(
    () =>
      path.split("\\").map((pathName, index, array) => ({
        pathName: index === 0 ? userName : pathName,
        url: array.slice(0, index + 1).join("\\"),
      })),
    [path]
  );

  const handleLikClick = async (url) => {
    setQuery((prev) => ({ ...prev, path: url, search: "" }));
    setSearchedText("");
  };

  return (
    <Grid container>
      <Breadcrumbs aria-label="breadcrumb" className="mb-1">
        <StyledLink onClick={() => handleLikClick("")} color="inherit">
          Home
        </StyledLink>
        {paths.map(({ pathName, url }, index, array) =>
          index === array.length - 1 ? (
            <Typography key={index} color="text.primary">
              {pathName.replace("_", " ")}
            </Typography>
          ) : (
            <StyledLink
              onClick={() => handleLikClick(url)}
              color="inherit"
              key={index}
            >
              {pathName.replace("_", " ")}
            </StyledLink>
          )
        )}
      </Breadcrumbs>
    </Grid>
  );
};

DocumentBreadcrumb.propTypes = {
  path: PropTypes.array,
  setQuery: PropTypes.func,
  userName: PropTypes.string,
  setSearchedText: PropTypes.func,
};

export default DocumentBreadcrumb;
